/**
 * NotFoundPage — shown for any URL that matches no route (the `*` route).
 *
 * A real 404 (not a blank screen) reassures the user the app still works and
 * gives them a way back. This one renders WITHOUT the customer layout, because
 * it also catches malformed URLs that should not show the full shell.
 */

import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import { Button } from '@/components/ui';
import { ROUTES } from '@/constants/routes';

export function NotFoundPage() {
  return (
    <main className="grid min-h-dvh place-items-center bg-canvas px-4">
      <div className="text-center">
        <p className="bg-gradient-to-br from-primary-500 to-primary-800 bg-clip-text text-7xl font-black text-transparent sm:text-8xl">
          404
        </p>
        <h1 className="mt-4 text-xl font-bold text-ink">This page took a wrong turn</h1>
        <p className="mx-auto mt-2 max-w-sm text-sm text-muted">
          The page you are looking for does not exist or may have moved. Let’s get you back on
          track.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link to={ROUTES.home}>
            <Button leftIcon={<Home size={18} />}>Go home</Button>
          </Link>
          <Link to={ROUTES.search}>
            <Button variant="secondary" leftIcon={<Search size={18} />}>
              Search
            </Button>
          </Link>
        </div>
      </div>
    </main>
  );
}

export default NotFoundPage;
